import React, { useState } from 'react'
import { Box, Typography, Grid, Divider, Container, Dialog, DialogTitle, DialogActions, Button } from '@mui/material'
import Logo from '../../assets/images/oujat.png'
import FaceBookLogo from '../../assets/images/FacebookIcon.svg'
import LinkdinLogo from '../../assets/images/LinkdinIcon.svg'
import InstragramLogo from '../../assets/images/InstragramIcon.svg'
import SocialMedia1 from 'src/assets/images/Social Media Icon1.png'
import SocialMedia2 from 'src/assets/images/Social Media Icon2.png'
import SocialMedia3 from 'src/assets/images/Social Media Icon3.png'
import SocialMedia4 from 'src/assets/images/Social Media Icon4.png'
import SocialMedia5 from 'src/assets/images/Social Media Icon5.png'
import SocialMedia6 from 'src/assets/images/Social Media Icon6.png'
import SocialMedia7 from 'src/assets/images/Social Media Icon7.png'
import SocialMedia8 from 'src/assets/images/Social Media Icon8.png'
import SocialMedia9 from 'src/assets/images/Social Media Icon9.png'
import SocialMedia10 from 'src/assets/images/Social Media Icon10.png'
import SocialMedia11 from 'src/assets/images/Social Media Icon11.png'
import SocialMedia12 from 'src/assets/images/Social Media Icon12.png'
import SocialMedia13 from 'src/assets/images/Social Media Icon13.png'
import SocialMedia14 from 'src/assets/images/Social Media Icon14.png'
import SocialMedia15 from 'src/assets/images/Social Media Icon15.png'
import SocialMedia16 from 'src/assets/images/Social Media Icon16.png'
import SocialMedia17 from 'src/assets/images/Social Media Icon17.png'

import { Link, useLocation } from 'react-router-dom'

const Footer = () => {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const media = [
    {
      image: SocialMedia1
    },
    {
      image: SocialMedia2
    },
    {
      image: SocialMedia3
    },
    {
      image: SocialMedia4
    },
    {
      image: SocialMedia5
    },
    {
      image: SocialMedia6
    },
    {
      image: SocialMedia7
    },
    {
      image: SocialMedia8
    },
    {
      image: SocialMedia9
    },
    {
      image: SocialMedia10
    },
    {
      image: SocialMedia11
    },
    {
      image: SocialMedia12
    },
    {
      image: SocialMedia13
    },
    {
      image: SocialMedia14
    },
    {
      image: SocialMedia15
    },
    {
      image: SocialMedia16
    },
    {
      image: SocialMedia17
    }
  ]

  const links = [
    { path: '/policies-rules-page', label: 'Policies and Rules' },
    { path: '/legal-notice-page', label: 'Legal Notice' },
    { path: '/service-listing-policy-page', label: 'Service Listing Policy' },
    { path: '/privacy-policy-page', label: 'Privacy Policy' },
    { path: '/terms-of-use-page', label: 'Terms of Use' }
  ];

  const handleOpen = () => setOpen(true);
  const handleClose = (url) => {
    setOpen(false);
    if (url) window.open(url, '_blank');
  };

  return (
    <>
      <Box
        sx={{
          bgcolor: '#F6F6F6',
          px: { xs: 1, md: 3, lg: 3 },
          py: { xs: 1, md: 3, lg: 3 }
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mt: '30px', mb: '30px' }}>
          <img src={Logo} alt='logo' sx={{ mt: '35x' }} />
        </Box>
        <Container maxWidth='xl'>
          <Grid container spacing={10}>
            <Grid item xs={12} sm={6} md={2}>
              <Typography
                variant='fm-p1'
                sx={{
                  fontWeight: 500,
                  color: 'common.black'
                }}
              >
                Get support
              </Typography>
              <Box sx={{ my: 3 }}>
                <Link to='/help-center' style={{ textDecoration: 'none' }}>
                  <Typography
                    variant='fm-p1'
                    sx={{
                      fontWeight: 500,
                      color: '#8E8E8E'
                    }}
                  >
                    Help center
                  </Typography>
                </Link>
              </Box>
              <Box sx={{ my: 3 }}>
                {/* <Link to='/' style={{ textDecoration: 'none' }}> */}
                <Typography
                  variant='fm-p1'
                  sx={{
                    fontWeight: 500,
                    color: '#8E8E8E'
                  }}
                >
                  Live chat
                </Typography>
                {/* </Link> */}
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Typography
                variant='fm-p1'
                sx={{
                  fontWeight: 500,
                  color: 'common.black'
                }}
              >
                Payments and Protections
              </Typography>
              <Box sx={{ my: 3 }}>
                <Link to='/securedpayments' style={{ textDecoration: 'none' }}>
                  <Typography
                    variant='fm-p1'
                    sx={{
                      fontWeight: 500,
                      color: '#8E8E8E'
                    }}
                  >
                    Secured and easy payments
                  </Typography>
                </Link>
              </Box>
              <Link to='/oujat-digital-wallet-page' style={{ textDecoration: 'none' }}>
                <Typography
                  variant='fm-p1'
                  sx={{
                    fontWeight: 500,
                    color: '#8E8E8E'
                  }}
                >
                  Oujat Digital Wallet
                </Typography>
              </Link>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <Typography
                variant='fm-p1'
                sx={{
                  fontWeight: 500,
                  color: 'common.black'
                }}
              >
                Ship on Oujat.com
              </Typography>
              <Box sx={{ my: 3 }}>
                <Link to='/customerstype' style={{ textDecoration: 'none' }}>
                  <Typography
                    variant='fm-p1'
                    sx={{
                      fontWeight: 500,
                      color: '#8E8E8E'
                    }}
                  >
                    The customers
                  </Typography>
                </Link>
              </Box>
              <Box sx={{ my: 3 }}>
                <Link to='/agentcategories' style={{ textDecoration: 'none' }}>
                  <Typography
                    variant='fm-p1'
                    sx={{
                      fontWeight: 500,
                      color: '#8E8E8E'
                    }}
                  >
                    The Agents
                  </Typography>
                </Link>
              </Box>
              <Box sx={{ my: 3 }}>
                <Link to='/oujatreads' style={{ textDecoration: 'none' }}>
                  <Typography
                    variant='fm-p1'
                    sx={{
                      fontWeight: 500,
                      color: '#8E8E8E'
                    }}
                  >
                    Oujat.com Reads
                  </Typography>
                </Link>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Typography
                variant='fm-p1'
                sx={{
                  fontWeight: 500,
                  color: 'common.black'
                }}
              >
                Become an agent
              </Typography>
              <Box sx={{ my: 3 }}>
                <Link to='/how-it-works' style={{ textDecoration: 'none' }}>
                  <Typography
                    variant='fm-p1'
                    sx={{
                      fontWeight: 500,
                      color: '#8E8E8E'
                    }}
                  >
                    How it works
                  </Typography>
                </Link>
              </Box>
              <Box sx={{ my: 3 }}>
                <Typography
                  variant='fm-p1'
                  sx={{ fontWeight: 500, color: '#8E8E8E', cursor: 'pointer' }}
                  onClick={handleOpen}
                >
                  Register/Login
                </Typography>
                {/* Dialog Box */}
                <Dialog
                  open={open}
                  onClose={() => handleClose()}
                  aria-labelledby='alert-dialog-title'
                  aria-describedby='alert-dialog-description'
                >
                  <DialogTitle id='alert-dialog-title' sx={{ textAlign: 'center', fontSize: '1.5rem', fontWeight: 'bold' }}>
                    Login
                  </DialogTitle>

                  <DialogActions sx={{ justifyContent: 'center' }}>
                    <Button
                      variant='contained'
                      color='primary'
                      target='_blank'
                      onClick={() => handleClose('https://www.customer.oujat.com/login')}
                      sx={{
                        textDecoration: 'none',
                        width: '100%'
                      }}
                    >
                      Customer
                    </Button>
                    <Button
                      variant='contained'
                      color='primary'
                      target='_blank'
                      onClick={() => handleClose('https://www.agent.oujat.com/login')}
                      sx={{
                        textDecoration: 'none',
                        width: '100%'
                      }}
                    >
                      Agent
                    </Button>
                  </DialogActions>
                </Dialog>
              </Box>
              <Box sx={{ my: 3 }}>
                <Link to='/subscription-page' style={{ textDecoration: 'none' }}>
                  <Typography
                    variant='fm-p1'
                    sx={{
                      fontWeight: 500,
                      color: '#8E8E8E'
                    }}
                  >
                    Subscription package
                  </Typography>
                </Link>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={2}>
              <Typography
                variant='fm-p1'
                sx={{
                  fontWeight: 500,
                  color: 'common.black'
                }}
              >
                Company
              </Typography>
              <Box sx={{ my: 3 }}>
                <Link to='/aboutus' style={{ textDecoration: 'none' }}>
                  <Typography
                    variant='fm-p1'
                    sx={{
                      fontWeight: 500,
                      color: '#8E8E8E'
                    }}
                  >
                    About Oujat.com
                  </Typography>
                </Link>
              </Box>
              <Box sx={{ my: 3 }}>
                <Link to='/career' style={{ textDecoration: 'none' }}>
                  <Typography
                    variant='fm-p1'
                    sx={{
                      fontWeight: 500,
                      color: '#8E8E8E'
                    }}
                  >
                    Career
                  </Typography>
                </Link>
              </Box>
            </Grid>
            <Grid item container xs={12} spacing={2}>
              {media?.map((i, index) => (
                <Grid item key={index}>
                  <img src={i?.image} alt='' />
                </Grid>
              ))}
            </Grid>
            <Grid item xs={12} display='flex' alignItems={'center'} gap={3}>
              <Typography
                variant='fm-h6'
                sx={{
                  fontWeight: 500,
                  color: 'common.black'
                }}
              >
                Follow Us On
              </Typography>
              <Box
                sx={{
                  display: 'flex', mt: 2,
                  gap: 3,
                }}
              >
                <Link
                  target='_blank'
                  to='https://www.facebook.com/Oujattechnologies?mibextid=ZbWKwL'
                  style={{ textDecoration: 'none' }}
                >
                  <img src={FaceBookLogo} alt='Facebook logo' style={{ height: '31px', width: '31px' }} />
                </Link>
                <Link
                  to='https://www.linkedin.com/company/oujat-technologies/'
                  target='_blank'
                  style={{ textDecoration: 'none' }}
                >
                  <img src={LinkdinLogo} alt='LinkedIn logo' style={{ height: '31px', width: '31px' }} />
                </Link>
                <Link
                  target='_blank'
                  to='https://www.instagram.com/oujattech/profilecard/?igsh=eTVzaTl4enM0OWV6'
                  style={{ textDecoration: 'none' }}
                >
                  <img src={InstragramLogo} alt='InstragramLogo' style={{ height: '31px', width: '31px' }} />
                </Link>
              </Box>
            </Grid>
          </Grid>
          <Divider sx={{ borderColor: '#AAAAAA' }} />
          <Box sx={{ display: { md: 'flex' }, justifyContent: 'space-between', alignItems: 'center', p: 3 }}>
            <Typography
              sx={{
                fontSize: '16px',
                lineHeight: '24px',
                color: '#5E5E5E',
                textAlign: { xs: 'center', sm: 'left' }
              }}
            >
              © Copyright {new Date().getFullYear()}, All Rights Reserved
            </Typography>
            <Box sx={{ display: { md: 'flex' }, gap: 4 }}>
              {links.map((link) => {
                const isActive = location.pathname === link.path;
                return (
                  <Link
                    key={link.path}
                    to={isActive ? '#' : link.path}
                    style={{ textDecoration: 'none', pointerEvents: isActive ? 'none' : 'auto' }}
                  >
                    <Typography
                      variant='fm-p2'
                      sx={{ fontWeight: 500, color: isActive ? 'gray' : '#5E5E5E' }}
                    >
                      {link.label}
                    </Typography>
                  </Link>
                );
              })}
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  )
}

export default Footer
